import React from 'react';
import {Route, Router} from 'react-router-dom';
import {apiUrl} from './libs/api';
import {AbilityContext} from './ability-context'
import ability from './ability'
import qs from 'qs';

import history from './libs/history';


import MainRouter from './MainRouter';
import {PageLoader} from "./ui/components/Loader";
import backButton from "./libs/backButton";

// import Subscription from "./ui/components/ModalSubscription";
/*
const delay = async (timeInSeconds) => {
    return new Promise((resolve) => {
        setInterval(resolve, timeInSeconds * 1000);
    })
}*/

class Main extends React.Component {
    constructor(props) {
        super(props);
        let {atoken, forced = false} = qs.parse(props.location.search, {ignoreQueryPrefix: true});
        this.state = {
            tokenLoading: !!atoken,
            atoken,
            forced
        }
        let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "";

        if(!source){
            if(!localStorage.getItem(process.env.REACT_APP_TOKEN_NAME) && window.location.hash.match(/[#&]source=nouslib/)){
                localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_source`, "nouslib");
                source = "nouslib";
            }
            else{
                localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_source`, "voissa");
                source = "voissa";
            }
        }
        if(!["voissa", "nouslib"].includes(source)){
            localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_source`, "voissa");
            source = "voissa";
        }

        let isBackbutton = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_fromdsiclaimer`) || "0";
        if(isBackbutton.toString() === "1"){
            backButton("popover", {source});
            localStorage.removeItem(`${process.env.REACT_APP_TOKEN_NAME}_fromdsiclaimer`);
        }

        if(window.location.hash.match(/[#&]hist=1/)){
            backButton("popundercallback", {source});
        }
        let newHash = window.location.hash.replace(/(.*)[#&]disc=1(.*)/, '$1$2').replace(/(.*)[#&]hist=1(.*)/, '$1$2').replace(/(.*)[#&]source=[a-z]*\b(.*)/, '$1$2');
        window.history.replaceState(null, document.title, window.location.pathname + window.location.search + newHash);

    }



    async componentDidMount() {
        if (this.state.atoken) {
            if(this.state.forced){
                localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);
            }
            const currentToken = await localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
            let response = await apiUrl.post(
                '/users/accounts/verify-token',
                {ephemeralToken: this.state.atoken, currentToken}
            );
            if (response.data.status) {
                await localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, response.data.token);
            }



            this.setState({tokenLoading: false}, ()=>{
                setTimeout(()=>{
                    let params = new URLSearchParams(window.location.search);
                    params.delete("atoken");
                    params = params.toString();
                    if (params.length) {
                        params = `?${params}`;
                    }
                    window.location.search = params;

                    window.history.replaceState(null, document.title, window.location.pathname + window.location.search + window.location.hash);
                },1000);
            });

        }
    }


    shouldComponentUpdate(nextProps, nextState) {
        if(this.props.location.hash !== nextProps.location.hash){
            return true;
        }
        return nextState.tokenLoading !== this.state.tokenLoading

    }

    render() {
        return this.state.tokenLoading ? <PageLoader/> : <MainRouter/>
    }
}

export default (
    <AbilityContext.Provider value={ability}>
        <Router history={history}>
            <Route path="/" component={Main}/>
        </Router>
    </AbilityContext.Provider>
);